import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromStore from '../../../store';
import {catchError, concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {EMPTY, Observable, of} from 'rxjs';
import { DeviceMgtListActionTypes, DeviceMgtListActions } from '../actions/device-mgt-list.actions';
import {DeviceMgtService} from '../../../services/device-mgt.service';
import {Store} from '@ngrx/store';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';
import * as featureActions from '../../index';
import {DeviceSettingListActionTypes} from '../../index';


@Injectable()
export class DeviceMgtListEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private deviceMgtService = inject(DeviceMgtService);

  constructor() {}


  // Device Management List
  GetDeviceMgtLists$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceMgtListActionTypes.GetDeviceMgtLists),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([actions, user]: [any, any]) => {
      const params = {otp: user.otp};
      return this.deviceMgtService.ReadDeviceMgtList(params).pipe(
        switchMap((res) => {
          if (res.result && !!res.msg.body && Array.isArray(res.msg.body)) {
            const data = res.msg.body;
            const dcodeList = data.map(item => parseInt(item.dcode, 10));
            if (actions.payload && !actions.payload.syncAccountsInfo) {
              return of(
                new featureActions.GetDevices(dcodeList),
                new featureActions.LoadDeviceMgtLists(res.msg.body));
            } else {
              return of(
                new featureActions.GetAccounts(),
                new featureActions.GetDevices(dcodeList),
                new featureActions.LoadDeviceMgtLists(res.msg.body));
            }
          }
          return of(new featureActions.LoadDeviceMgtLists([]));
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetDeviceMgtListsFail());
        })
      );
    })
  ));

  // Device Setting List
  GetDeviceSettingLists$ = createEffect(() => this.actions$.pipe(
    ofType(DeviceSettingListActionTypes.GetDeviceSettingLists),
    map((action: featureActions.GetDeviceSettingLists) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const param = (payload !== null && payload.regionIds !== null && payload.regionIds !== undefined) ?
                    {otp: user.otp, acode: payload.acode, RegionIds: payload.regionIds} : (payload !== null && payload.acode !== null && payload.acode !== undefined) ? {otp: user.otp, acode: payload.acode} : {otp: user.otp};
      return this.deviceMgtService.ReadDeviceMgtList(param).pipe(
        switchMap((res) => {
          if (res.result && !!res.msg.body && Array.isArray(res.msg.body)) {
            const data = res.msg.body;
            const dcodeList = data.map(item => parseInt(item.dcode, 10));
            return of(new featureActions.LoadDeviceSettingLists(res.msg.body));
          }
          return of(new featureActions.LoadLicenseSettingLists([]));
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of (new featureActions.GetDeviceSettingListsFail());
        })
      );
    })
  ));
  DeleteDeviceSettingList$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.DeviceSettingListActionTypes.GetDeleteDeviceSettingList),
    map((action: featureActions.GetDeleteDeviceSettingList) => action.payload.dcode),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        dcode: payload
      };
      return this.deviceMgtService.DeleteDeviceSettingList(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.DeleteDeviceSettingList };
          if (result.result) {
            return [new featureActions.DeleteDeviceSettingList({id: params.dcode}), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            return [new featureActions.UpdateInfoFailAction(result)];
          }}
        ),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteDeviceSettingList
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));

}
